module.exports = __webpack_public_path__ + "static/img/编组8.19322eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/编组8.png
// module id = jnSs
// module chunks = 1